var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCameraIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 23,
    viewBox: "0 0 27 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7891 0.907895V5.75C21.7891 6.25116 22.1958 6.65789 22.697 6.65789C23.1981 6.65789 23.6049 6.25116 23.6049 5.75V0.907895C23.6049 0.406737 23.1981 0 22.697 0C22.1958 0 21.7891 0.406737 21.7891 0.907895Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2751 4.23766H25.1172C25.6183 4.23766 26.0251 3.83093 26.0251 3.32977C26.0251 2.82861 25.6183 2.42188 25.1172 2.42188H20.2751C19.7739 2.42188 19.3672 2.82861 19.3672 3.32977C19.3672 3.83093 19.7739 4.23766 20.2751 4.23766Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4342 0.605469H9.52442C8.72184 0.605469 7.98826 1.05942 7.62995 1.77605L6.48358 4.07C6.43153 4.17168 6.32742 4.23705 6.21242 4.23705H3.32895C1.49016 4.23705 0 5.72721 0 7.566V19.6713C0 20.5537 0.351053 21.4011 0.974474 22.0257C1.59911 22.6492 2.44647 23.0002 3.32895 23.0002C7.96768 23.0002 18.0586 23.0002 22.6974 23.0002C23.5798 23.0002 24.4272 22.6492 25.0518 22.0257C25.6753 21.4011 26.0263 20.5537 26.0263 19.6713C26.0263 15.9828 26.0263 9.38178 26.0263 9.38178C26.0263 8.88063 25.6196 8.47389 25.1184 8.47389C24.6173 8.47389 24.2105 8.88063 24.2105 9.38178C24.2105 9.38178 24.2105 15.9828 24.2105 19.6713C24.2105 20.0732 24.0507 20.4569 23.7675 20.7414C23.483 21.0246 23.0993 21.1844 22.6974 21.1844H3.32895C2.92705 21.1844 2.54332 21.0246 2.25884 20.7414C1.97558 20.4569 1.81579 20.0732 1.81579 19.6713V7.566C1.81579 6.73073 2.49368 6.05284 3.32895 6.05284H6.21242C7.015 6.05284 7.74858 5.59889 8.10689 4.88226L9.25326 2.58831C9.30532 2.48663 9.40942 2.42126 9.52442 2.42126H15.4342C15.9354 2.42126 16.3421 2.01452 16.3421 1.51336C16.3421 1.01221 15.9354 0.605469 15.4342 0.605469Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0117 7.26172C9.83772 7.26172 7.26172 9.83772 7.26172 13.0117C7.26172 16.1857 9.83772 18.7617 13.0117 18.7617C16.1857 18.7617 18.7617 16.1857 18.7617 13.0117C18.7617 9.83772 16.1857 7.26172 13.0117 7.26172ZM13.0117 9.07751C15.1834 9.07751 16.9459 10.84 16.9459 13.0117C16.9459 15.1834 15.1834 16.9459 13.0117 16.9459C10.84 16.9459 9.07751 15.1834 9.07751 13.0117C9.07751 10.84 10.84 9.07751 13.0117 9.07751Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraIcon);
export default __webpack_public_path__ + "static/media/cameraIcon.2db6a0eee28a45e48f3aa8fa3ec82d43.svg";
export { ForwardRef as ReactComponent };